const STOP_WORDS = new Set([
  "a",
  "an",
  "and",
  "at",
  "for",
  "in",
  "of",
  "on",
  "or",
  "the",
  "to",
]);

/**
 * Builds optional search chip labels from an entity title/name.
 * Does not call APIs — chips only populate the search input.
 */
export const buildSearchSuggestions = (keyword) => {
  const trimmed = String(keyword || "").trim();
  if (!trimmed) return [];

  const suggestions = new Set([trimmed]);

  const withoutYear = trimmed.replace(/\s+\d{4}\s*$/, "").trim();
  if (withoutYear) suggestions.add(withoutYear);

  const words = withoutYear.split(/\s+/).filter(Boolean);

  if (words.length >= 2) {
    suggestions.add(words.slice(0, 2).join(" "));
  }
  if (words.length >= 3) {
    suggestions.add(words.slice(0, 3).join(" "));
  }
  if (words.length >= 2) {
    suggestions.add(words.slice(-2).join(" "));
  }

  const meaningful = words.filter(
    (word) => !STOP_WORDS.has(word.toLowerCase()) && word.length > 2
  );
  if (meaningful.length >= 2) {
    suggestions.add(meaningful.slice(0, 2).join(" "));
  }

  return Array.from(suggestions).filter(Boolean).slice(0, 4);
};
